import clsx from "clsx";
import { ReactNode } from "react";

import { Evolution } from "../../../../../redux/evolutions/evolutionsSlice";

// export const EvolutionPathNode

export const EvolutionPathDash = () => (
  <div className="flex">
    <div className="w-2 md-lg:w-3 h-[2px] bg-[#ECD882] my-auto" />
  </div>
);

export const EvolutionPathNode = ({ children }: { children: ReactNode }) => (
  <div
    className={clsx(
      "p-1 px-1 md-lg:px-2 rounded-md text-[#DAC56B] bg-evolution-primary",
      "text-[8px] md-lg:text-tiny touch-device:text-xs",
    )}
  >
    {children}
  </div>
);

export const EvolutionPath = ({
  evolutionPath,
  evolutions,
}: {
  evolutionPath: number[];
  evolutions: Evolution[];
}) => {
  return (
    <>
      {evolutionPath?.map((evo, i) => (
        <div
          className="flex items-center whitespace-nowrap mobile:whitespace-normal"
          key={evo}
        >
          <EvolutionPathNode>
            {evolutions?.find((e) => evo === e.id)?.name}
          </EvolutionPathNode>
          {i < evolutionPath.length - 1 && <EvolutionPathDash />}
        </div>
      ))}
    </>
  );
};
